<template>
  <div class="new-input-box" v-loading="checkLoading">
    <input-form
      :inputData="myformInfo"
      @toParentVal="submitFormFun"
      :btnPosition1="true"
    ></input-form>
    <el-tooltip
      class="item"
      effect="dark"
      content="当前账号没有创建权限，请联系管理员添加。"
      placement="top"
      v-if="!permissions.includes('platform:benefit:create')"
    >
      <el-button type="primary" disabled>创建任务</el-button>
    </el-tooltip>
    <el-button type="primary" v-else @click="createTasks">创建任务</el-button>
    <!-- <el-checkbox
      v-model="form.createByMe"
      style="margin-left: 20px"
      @change="handleCreateByMe"
      >我创建的</el-checkbox
    > -->
    <div class="new-table-box batch-table" style="margin-top: 12px">
      <el-table
        :data="tableData"
        :expand-row-keys="expandKeys"
        :tree-props="{ children: 'couponList' }"
        rowKey="id"
        v-loading="talbeLoading"
        style="width: 100%; border: 1px solid #f0f0f0;"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column prop="taskName" label="任务名称" width="200">
        </el-table-column>
        <el-table-column label="优惠券名称" width="200">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.couponList && scope.row.couponList.length > 0
                  ? "--"
                  : scope.row.couponName
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="优惠券信息" width="200">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.couponList && scope.row.couponList.length > 0
                  ? "--"
                  : scope.row.couponDetail
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="优惠券归属店铺" width="200">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.couponList && scope.row.couponList.length > 0
                  ? "--"
                  : scope.row.belongShopTitle
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sendNum" label="预计发放数" width="200">
        </el-table-column>
        <el-table-column label="实际发放数" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.rowId ? "" : scope.row.successNum }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="任务状态" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.rowId">
              <jd-status :status="2" v-if="scope.row.status == 0"
                >待执行</jd-status
              >
              <jd-status :status="1" v-else-if="scope.row.status == 1"
                >执行中</jd-status
              >
              <jd-status :status="4" v-else-if="scope.row.status == 2"
                >执行结束</jd-status
              >
              <jd-status :status="4" v-else>已终止</jd-status>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="任务类型" width="200">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.rowId
                  ? ""
                  : scope.row.type == 1
                  ? "定时发送"
                  : "立即发送"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发送时间" width="200">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.sendTime
                  ? scope.row.sendTime
                  : scope.row.rowId
                  ? ""
                  : "-"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="完成时间" width="200">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.status == 0 ||
                scope.row.status == 1 ||
                scope.row.status == 3
                  ? "-"
                  : scope.row.finishTime
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200">
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.type == 1 && scope.row.status == 0"
              type="text"
              class="btn-style"
              @click="handleStop(scope.row)"
              >终止</el-button
            >
            <el-button
              type="text"
              v-if="!scope.row.rowId"
              class="btn-style"
              @click="checkDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              type="text"
              class="btn-style"
              v-if="!scope.row.couponList"
              @click="checkGrant(scope.row)"
              >发放明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="pagination-box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="text-align: right"
          :current-page="form.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="form.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="numTotal"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="couponFromDisable ? '查看任务详情' : '批量发放优惠券'"
      :visible.sync="couponDialogShow"
      @close="closeCouponDialog"
      width="1100px"
    >
      <el-form
        :model="couponFrom"
        label-width="121px"
        ref="couponFrom"
        :rules="couponFromRules"
        v-loading="lookLoading"
      >
        <el-form-item label="任务名称：" prop="taskName">
          <el-input
            v-model="couponFrom.taskName"
            style="width: 508px"
            placeholder="请输入"
            maxlength="30"
            show-word-limit
            :disabled="couponFromDisable"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务类型：" prop="type" required>
          <el-radio-group
            :disabled="couponFromDisable"
            v-model="couponFrom.type"
          >
            <el-radio :label="0">立即发送</el-radio>
            <el-radio :label="1">定时发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="发送时间："
          prop="sendTime"
          v-if="couponFrom.type == 1"
        >
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              size="small"
              v-model="couponFrom.sendTime"
              :picker-options="pickerOptions2"
              :clearable="false"
              :disabled="couponFromDisable"
            >
            </el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearSendTime"
            ></i>
            <img
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
        </el-form-item>
        <el-form-item label="添加人群：" prop="selectCrowdType">
          <el-radio-group
            :disabled="couponFromDisable"
            v-model="couponFrom.selectCrowdType"
            @change="selectCrowdTypeChange"
          >
            <el-radio :label="2">输入pin</el-radio>
            <el-radio :label="3">导入pin</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="couponFrom.selectCrowdType == 2">
          <el-form-item label="输入pin：" prop="pinList">
            <el-input
              style="width: 450px"
              type="textarea"
              placeholder="请输入"
              v-model="couponFrom.pinList"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :disabled="couponFromDisable"
            >
            </el-input>
            <jd-tips margin="16px 0">
              <div>注：1. 支持输入明文pin，每行一个用户pin；</div>
              <div style="margin-left: 32px;">
                2.手动输入，一次输入最多支持2000行
              </div>
              <div style="margin-left: 32px;">
                3.为避免用户pin重复导致多发情况，建议创建优惠券时设置限领规则。
              </div>
            </jd-tips>
          </el-form-item>
        </template>
        <template v-if="couponFrom.selectCrowdType == 3">
          <el-form-item label="选择文件：" class="upload_item" prop="fileUrl">
            <div>
              <div>
                <el-upload
                  v-if="!couponFromDisable"
                  ref="uploadFile"
                  class="upload_box"
                  :on-remove="removeFile"
                  :file-list="fileList"
                  action="#"
                  :multiple="false"
                  :limit="2"
                  :show-file-list="true"
                  :before-upload="beforeUpload"
                  :http-request="httpUpload"
                >
                  <el-button
                    type="primary"
                    :isZoom="true"
                    zName="上传文件"
                    label="上传文件"
                    size="small"
                  >
                    点击上传文件
                  </el-button>
                </el-upload>
                <div
                  style="position: absolute; top: 0; left: 150px"
                  v-if="!couponFromDisable"
                >
                  <div>
                    <i class="el-icon-loading" v-if="!uploadStatus"></i>
                    <i
                      class="el-icon-success"
                      style="color: green"
                      v-if="uploadStatus === 1"
                    ></i>
                    <i
                      class="el-icon-error"
                      style="color: red"
                      v-if="uploadStatus === 2"
                    ></i>
                    <span v-if="!uploadStatus">上传中</span>
                    <span v-if="uploadStatus === 1">上传成功</span>
                    <span v-if="uploadStatus === 2">上传失败</span>
                  </div>
                </div>
                <el-input
                  v-model="couponFrom.fileUrl"
                  style="display: none"
                ></el-input>
                <div v-if="couponFromDisable">{{ couponFrom.fileName }}</div>
              </div>
              <jd-tips margin="16px 0">
                <div>
                  注：1. 下载模板后编辑: 支持输入明文pin；
                  <a
                    v-if="couponFrom.selectCrowdType == 3"
                    target="_blank"
                    style="color: #7b61ff"
                    href="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E5%AF%BC%E5%85%A5%E6%89%B9%E9%87%8F%E5%8F%91%E6%94%BE%E6%A8%A1%E6%9D%BF.xlsx"
                    >点击下载模板</a
                  >
                </div>
                <div style="margin-left: 32px;">
                  2. 支持csv、xls、xlsx格式上传，大小限制在50M内。
                </div>
                <div style="margin-left: 32px;">
                  3.为避免用户pin重复导致多发情况，建议创建优惠券时设置限领规则。
                </div>
              </jd-tips>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="选择优惠券：" v-if="!couponFromDisable" required>
          <div style="display: flex">
            <el-button @click="selectCoupon" class="btn-auto">
              {{
                couponFrom.couponList && couponFrom.couponList.length > 0
                  ? "已选" + couponFrom.couponList.length + "张优惠券"
                  : "选择优惠券"
              }}
            </el-button>
          </div>
        </el-form-item>
        <div
          style="margin-left: 25px"
          v-if="coupon.couponName && !coupon.couponList"
          class="fz14"
        >
          <div style="display: flex">
            <div>
              <span>优惠券名称：</span>
              <span>{{ coupon.couponName }}</span>
            </div>
            <div style="margin-left: 80px">
              <span>优惠券归属店铺：</span>
              <span>{{ coupon.shopTitle }}</span>
            </div>
            <div style="margin-left: 80px">
              <span>优惠券信息：</span>
              <span>{{ coupon.couponDetail }}</span>
            </div>
          </div>
          <div class="coupon-time">
            <div class="time-label">领取时间：</div>
            <div>{{ coupon.takeBeginTime }} 至 {{ coupon.takeEndTime }}</div>
          </div>
          <div class="coupon-time" v-if="coupon.validity">
            <div class="time-label">有效期：</div>
            <div>{{ coupon.validity }}</div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!couponFromDisable">
        <el-button type="primary" @click="batchCouponSure">确认</el-button>
        <el-button @click="closeCouponDialog">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="发放明细"
      :visible.sync="detailDialogShow"
      width="900px"
      @close="closeIntegralDialog"
    >
      <div class="detail_tip" v-loading="detailLoading">
        <jd-title label="优惠券信息" />
        <div class="flex-spc-x">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
            "
          >
            <div class="flexc-cen-x mt16">
              <div class="white-spacr-no">优惠券名称：</div>
              <div class="word-lineh">
                {{ grant.name }}
              </div>
            </div>
            <div class="flexc-cen-x mt16">
              <div class="white-spacr-no">优惠券信息：</div>
              <div class="word-lineh">
                {{ grant.couponDetail }}
              </div>
            </div>
            <div class="flexc-cen-x mt16">
              <div
                style="width: 85px; text-align: right"
                class="white-spacr-no"
              >
                有效期：
              </div>
              <div class="word-lineh">
                {{
                  grant.beginTime
                    ? `起:${grant.beginTime} 止:${grant.endTime}`
                    : `领取后${grant.addDays}天有效`
                }}
              </div>
            </div>
            <div class="flexc-cen-x mt16">
              <div
                style="width: 85px; display: inline-block; text-align: right"
              >
                已发放：
              </div>
              <div class="word-lineh">
                {{ grant.successNum }}
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
            "
          >
            <div class="flexc-cen-x mt16">
              <div
                style="width: 120px; text-align: right"
                class="white-spacr-no"
              >
                优惠券归属店铺：
              </div>
              <div class="word-lineh">
                {{ grant.shopTitle }}
              </div>
            </div>
            <div class="flexc-cen-x mt16">
              <div
                style="width: 120px; text-align: right"
                class="white-spacr-no"
              >
                领取时间：
              </div>
              <div class="word-lineh">
                <div>起：{{ grant.takeBeginTime }}</div>
                <div>止：{{ grant.takeEndTime }}</div>
              </div>
            </div>
            <div class="flexc-cen-x mt16">
              <div
                style="width: 120px; text-align: right"
                class="white-spacr-no"
              >
                总量：
              </div>
              <div class="word-lineh">
                {{ grant.num }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <input-form
        class="mb16"
        ref="formSearchRef"
        :inputData="detailFromInfo"
        @toParentVal="distributionBeansSure"
        :btnPosition1="true"
      ></input-form>
      <div class="mt12">
        <el-table
          :data="detailtableData"
          v-loading="detailtalbeLoading"
          style="width: 100%; border: 1px solid #f0f0f0;"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <el-table-column label="用户pin">
            <template slot-scope="scope">
              <div v-if="scope.row.customerPin && scope.row.customerPin != ''">
                <span class="pinBody" v-if="!scope.row.isShow">
                  <span class="pintitle">{{ scope.row.chaosPin }}</span>
                  <el-button
                    class="pinBu"
                    @click="showPin(scope.$index)"
                    type="text"
                    >显示全部</el-button
                  >
                </span>
                <span v-else>{{ scope.row.customerPin }}</span>
              </div>
              <!-- customerPin为空的话使用mixPin -->
              <div v-else>
                <span class="pinBody" v-if="!scope.row.isShow">
                  <span class="pintitle">{{ scope.row.chaosPin }}</span>
                  <el-button
                    class="pinBu"
                    @click="showPin(scope.$index)"
                    type="text"
                    >显示全部</el-button
                  >
                </span>
                <span v-else>{{ scope.row.mixPin }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="sendTime"
            label="发放时间"
          ></el-table-column>
          <el-table-column label="发放状态">
            <template slot-scope="scope">
              <div
                v-if="!scope.row.sendStatus"
                style="display: flex; align-items: center"
              >
                <jd-status :status="3">发放失败</jd-status>
                <el-tooltip :content="scope.row.failReason" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
              <div v-else><jd-status :status="0">发放成功</jd-status></div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="pagination-box">
          <el-pagination
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            style="text-align: right"
            :current-page="detailFrom.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="detailFrom.size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="detailTotal"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 选择优惠券 -->
    <selectPrize
      v-model="selectCouponShow"
      @closePrize="confirmCoupon"
      @close="selectCouponShow = false"
    ></selectPrize>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import jdStatus from "@/components/StatusTable/index.vue";
import jdTips from "@/components/common/jdTips.vue";
import selectPrize from "@/views/integralCenter/select_prize.vue";
import {
  createTask,
  queryTaskPage,
  uploadFile,
  queryRecordPage,
  stopTask,
  getTaskDetail,
  getCouponDetail,
  byPutKey,
} from "@/api/integralCenter/batchDistributionBenefits.js";
export default {
  name: "batchPublish",
  components: {
    inputForm,
    jdTips,
    selectPrize,
    jdStatus,
  },
  props: {
    showCreateDialog: {
      type: Boolean,
      default: false,
    },
    selectCrowdType: {
      type: Number,
      default: 2,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    isCurrentShop() {
      return this.coupon.venderId == this.venderId;
    },
    sendTimeLimit() {
      return new Date(this.couponFrom.sendTime).getTime() < Date.now();
    },
    couponTimeLimit() {
      return (
        new Date(this.couponFrom.sendTime).getTime() > this.coupon.takeEndTime
      );
    },
  },
  watch: {
    showCreateDialog: {
      handler: function(val) {
        if (val) {
          this.createTasks();
        }
      },
      immediate: true,
    },
    selectCrowdType: {
      handler: function(val) {
        this.couponFrom.selectCrowdType = val;
      },
      immediate: true,
    },
    "coupon.venderId"(val) {
      this.handleVenderId(val);
    },
    // "couponFrom.sendTime"(selectTime) {
    //   const date = new Date(
    //     new Date(selectTime).setHours(0, 0, 0, 0)
    //   ).getTime();
    //   const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
    //   if (date == today) {
    //     // 当选择的日期就是当天的时候，这个时候就要限制时间应当小于此时此刻的时分秒
    //     this.pickerOptions2.selectableRange =
    //       new Date().getHours() +
    //       ":" +
    //       (new Date().getMinutes() + 1) +
    //       ":00" +
    //       " - 23:59:59";
    //   } else {
    //     // 当选择的日期小于当天的时候，这时需要把时分秒的限制放开，否则不能选择
    //     this.pickerOptions2.selectableRange = "00:00:00 - 23:59:59";
    //   }
    // },
  },
  data() {
    return {
      lookLoading: false,
      detailLoading: false,
      myformInfo: [
        {
          name: "任务昵称：",
          val: "taskName",
          placeholder: "请输入",
        },
        {
          name: "任务状态：",
          val: "status",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "待执行", id: 0 },
            { label: "执行中", id: 1 },
            { label: "执行结束", id: 2 },
            { label: "已终止", id: 3 },
          ],
        },
        {
          name: "创建时间：",
          val: "createTime",
          myDate: true,
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "任务类型：",
          val: "type",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "立即发送", id: 0 },
            { label: "定时发送", id: 1 },
          ],
        },
      ],
      expandKeys: [],
      shopTips: "",
      selectLoading: false,
      currentShopTitle: "",
      shopList: [],
      couponDialogShow: false,
      selectCouponShow: false,
      detailDialogShow: false,
      form: {
        taskName: "",
        status: "",
        taskType: "",
        createTimeStart: "",
        createTimeEnd: "",
        sendType: 1,
        type: "",
        current: 1,
        size: 10,
        // createByMe: false,
      },
      pickerOptions2: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
        },
        // selectableRange:
        //   new Date().getHours() +
        //   ":" +
        //   (new Date().getMinutes() + 1) +
        //   ":00" +
        //   " - 23:59:59",
      },
      tableData: [],
      talbeLoading: false,
      numTotal: 0,
      couponFrom: {
        taskName: "",
        type: 0,
        sendTime: "",
        selectCrowdType: 2,
        pinList: "",
        fileName: "",
        fileUrl: "",
        couponName: "",
        couponList: [],
      },
      couponFromRules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        sendTime: [
          { required: true, message: "请选择发送时间", trigger: "blur" },
        ],
        selectCrowdType: [
          { required: true, message: "请选择添加人群", trigger: "change" },
        ],
        pinList: [
          { required: true, message: "请输入pin", trigger: "blur" },
        ],
        fileUrl: [{ required: true, message: "请上传文件", trigger: "change" }],
      },
      couponFromDisable: false,
      coupon: {
        venderId: "",
        couponDetail: "",
        couponId: "",
        couponName: "",
        takeBeginTime: "",
        takeEndTime: "",
        validity: "",
        validityType: "",
        addDays: "",
        couponType: "",
        putkey: "",
      },
      fileList: [],
      selectGoodsSkuList: [],
      selectCouponForm: {
        name: "",
        couponIdOrPutKey: "",
        status: "",
        couponKind: "",
        beginTime: this.getDateStr(-30) + " 00:00:00",
        endTime: this.getDateStr(0) + " 23:59:59",
        current: 1,
        size: 10,
        venderId: "",
      },
      filterBtnLoading: false,
      coupontableData: [],
      coupontalbeLoading: false,
      couponTotal: 0,
      detailFrom: {
        customerPin: "",
        sendStatus: "",
        sendType: 1,
        size: 10,
        current: 1,
      },
      detailFromInfo: [
        {
          name: "用户pin：",
          val: "customerPin",
          placeholder: "请输入",
        },
        {
          name: "发放状态：",
          val: "sendStatus",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "发放成功", id: 0 },
            { label: "发放失败", id: 1 },
          ],
        },
      ],
      detailtableData: [],
      detailTotal: 0,
      detailtalbeLoading: false,
      total: 0,
      uploadStatus: -1,
      checkLoading: false,
      grant: {
        addDays: "",
        takeBeginTime: "",
        takeEndTime: "",
        num: "",
        sendNum: "",
        couponDetail: "",
        name: "",
        beginTime: "",
        endTime: "",
        successNum: "",
      },
    };
  },
  created() {},
  mounted() {
    this.getBenefitList();
  },

  methods: {
    handleSizeChange(val) {
      this.form.size = val;
      this.getBenefitList();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getBenefitList();
    },
    handleSizeChange2(val) {
      this.detailFrom.size = val;
      this.getRecordList();
    },
    handleCurrentChange2(val) {
      this.detailFrom.current = val;
      this.getRecordList();
    },
    showPin(index) {
      this.detailtableData[index].isShow = true;
    },
    selectCrowdTypeChange() {
      // if (this.$refs["couponFrom"]) {
      //   this.$refs["couponFrom"].clearValidate();
      // }
      this.couponFrom.pinList = "";
    },
    isToTenMin(sendTime, delay) {
      let time1 = new Date(sendTime).getTime();
      let time2 = Date.now();
      let time3 = time1 - time2;
      return (time3 * 1) / (1000 * 60) < delay * 1;
    },
    clearSendTime() {
      this.couponFrom.sendTime = "";
    },
    handleStop(row) {
      this.$confirm("您确定要终止任务吗? 终止后任务将不会执行", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        if (this.isToTenMin(row.sendTime, 10)) {
          return this.$message.error("距离发送时间不足10分钟，无法取消发送哦");
        }
        stopTask(row.id).then((res) => {
          if (res.code == "1") {
            this.$message.success(res.message);
            this.getBenefitList();
          }
        }).catch((err) => {
    
        });
      });
    },
    handleVenderId(val) {
      this.shopList.forEach((item) => {
        if (item.venderId == val && item.venderId != this.venderId) {
          this.shopTips = "请登录【" + item.shopTitle + "】进行创建优惠券";
        }
      });
      this.coupon.couponName = "";
    },
    // handleCreateByMe() {
    //   this.form.current = 1;
    //   this.getBenefitList();
    // },
    getBenefitList() {
      this.talbeLoading = true;
      queryTaskPage(this.form).then((res) => {
        let list = res.data.records;
        this.tableData = list.map((v) => {
          if (v.couponList && v.couponList.length > 0) {
            v.couponList = v.couponList.map((e) => ({
              ...e,
              belongShopTitle:
                this.venderId == e.belongVenderId
                  ? e.belongShopTitle + "(当前店铺)"
                  : e.belongShopTitle,
              id: v.id + e.couponId,
              rowId: v.id,
              // successNum:v.successNum
            }));
          } else {
            v.couponList = null;
          }
          return v;
        });
        this.talbeLoading = false;
        this.numTotal = +res.data.total;
      });
    },
    submitFormFun(data) {
      this.form = {
        ...this.form,
        current: 1,
        size: 10,
        taskName: data.taskName || "",
        status: data.status,
        type: data.type,
        createTimeStart: data.createTimeStart || "",
        createTimeEnd: data.createTimeEnd || "",
      };
      this.getBenefitList();
    },
    handlePage({ pageNum, pageSize }) {
      this.form.current = pageNum;
      this.form.size = pageSize;
      this.getBenefitList();
    },
    clearTimeSendTime() {
      this.form.createTimeStart = "";
      this.form.createTimeEnd = "";
    },
    closeCouponDialog() {
      this.couponFrom = {
        taskName: "",
        type: 0,
        sendTime: "",
        selectCrowdType: 2,
        pinList: "",
        fileName: "",
        fileUrl: "",
        couponList: [],
      };
      this.coupon = {
        couponDetail: "",
        couponId: "",
        couponName: "",
        takeBeginTime: "",
        takeEndTime: "",
        validity: "",
        validityType: "",
        addDays: "",
        couponType: "",
        putkey: "",
        venderId: "",
      };
      this.uploadStatus = -1;
      this.couponDialogShow = false;
      this.fileList = []
      // this.$nextTick(() => {
      //   this.$refs.couponFrom.resetFields();
      // });
      this.$emit("resetDialog", false);
    },

    closeIntegralDialog() {
      this.grant = {
        addDays: "",
        takeBeginTime: "",
        takeEndTime: "",
        num: "",
        sendNum: "",
        couponDetail: "",
        name: "",
        beginTime: "",
        endTime: "",
      };
    },
    selectCoupon() {
      this.selectCouponShow = true;
    },
    confirmCoupon(val, row) {
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        this.couponFrom.couponList = [row];
      }
      this.$refs.couponFrom.clearValidate("couponList");
      this.selectCouponShow = false;
    },
    async batchCouponSure() {
      try {
        await this.$refs.couponFrom.validate();
        if (this.couponFrom.type == 1 && this.sendTimeLimit) {
          return this.$message.warning(
            "发送时间不能设置为过去的时间，请重新设置"
          );
        }
        if (this.couponFrom.couponList&&this.couponFrom.couponList.length == 0) {
          return this.$message.warning("请选择优惠券");
        }
        let params = {
          taskName: this.couponFrom.taskName,
          sendType: 1,
          type: this.couponFrom.type,
          sendTime: this.couponFrom.sendTime,
          selectCrowdType: this.couponFrom.selectCrowdType,
        };
        let coupons = [];
        this.couponFrom.couponList.forEach((v) => {
          coupons.push({
            couponId: v.couponId ? v.couponId : v.id,
            belongShopTitle: v.shopTitle,
            belongVenderId: v.venderId,
            couponName: v.name,
            couponDetail: this.getCouponDetailText(v),
            couponType: v.couponType,
            
            putkey: v.putkey || "",
            takeBeginTime: v.takeBeginTime,
            takeEndTime: v.takeEndTime,
            validityType: v.validityType,
            addDays: v.addDays,
          });
        });
        params.couponList = coupons;

        if (this.couponFrom.type == 1) {
          const timeOutCoupon = params.couponList.find(
            (v) =>
              this.moment(this.couponFrom.sendTime).valueOf() >
              this.moment(v.takeEndTime).valueOf()
          );
          if (timeOutCoupon) {
            return this.$message.warning(
              `发送时“${timeOutCoupon.couponName}”优惠券已失效，请重新设置发送时间或选择其他优惠券`
            );
          }
        }
        if (this.couponFrom.selectCrowdType == 2) {
          params.pinList = this.couponFrom.pinList.split("\n");
        } else if (
          this.couponFrom.selectCrowdType == 3 ||
          this.couponFrom.selectCrowdType == 4
        ) {
          params.fileName = this.couponFrom.fileName;
          params.fileUrl = this.couponFrom.fileUrl;
        } else if (this.couponFrom.type == 0) {
          delete params.sendTime;
        }
        createTask(params).then((res) => {
          if (res.code == 1) {
            this.couponDialogShow = false;
            this.$message.success("添加成功");
            this.getBenefitList();
            this.closeCouponDialog()
          } else {
            this.$message.warning(res.message);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    getCouponDetailText(row) {
      if (row) {
        let couponDetail = "";
        // 自营优惠券信息
        couponDetail = `满${row.quota}减${row.discount}元`;
        if (row.couponKind == 0) {
          couponDetail = `全品类东券,满${row.quota}减${row.discount}`;
        }
        if (row.couponKind == 1) {
          couponDetail = `限品类京券,满${row.quota}减${row.discount}`;
        }
        if (row.couponKind == 2) {
          couponDetail = `店铺东券,满${row.quota}减${row.discount}`;
        }
        if (row.couponKind == 3) {
          couponDetail = `限商品东券,满${row.quota}减${row.discount}`;
        }
        return couponDetail;
      } else {
        return "";
      }
    },
    removeFile(file, fileList) {
      console.log(file, fileList);
      this.couponFrom.fileUrl = "";
      this.couponFrom.fileName = "";
      this.uploadStatus = -1;
      this.fileList = [];
    },
    beforeUpload(file) {
      if (file.size / 1024 / 1024 > 50) {
        this.$message.warning("文件不得超过50M");
        return false;
      }
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    httpUpload({ file }) {
      console.log("file------------------", file);
      this.removeFile();
      let formData = new FormData();
      formData.append("file", file);
      this.uploadStatus = 0;
      console.log(formData);
      uploadFile(formData,5).then((res) => {
        console.log("上传文件------------------", res);
        if (res.code == 1) {
          this.uploadStatus = 1;
          this.couponFrom.fileUrl = res.data.fileUrl;
          this.couponFrom.fileName = file.name;
          this.fileList = [{ name: file.name, url: res.data.fileUrl }];
        } else {
          this.uploadStatus = 2;
        }
      });
    },
    createTasks() {
      this.couponList = [];
      this.couponDialogShow = true;
      this.couponFromDisable = false;
    },
    checkDetail(row) {
      this.couponDialogShow = true;
      this.lookLoading = true;
      getTaskDetail(row.id)
        .then((res) => {
          this.lookLoading = false;
          if (res.code == 1) {
            this.couponFromDisable = true;
            this.couponFrom.taskName = res.data.taskName;
            this.couponFrom.type = res.data.type;
            this.couponFrom.sendTime = res.data.sendTime;
            this.couponFrom.selectCrowdType = res.data.selectCrowdType;
            this.coupon.takeBeginTime = res.data.takeBeginTime;
            this.coupon.takeEndTime = res.data.takeEndTime;
            this.coupon.addDays = res.data.addDays;
            this.coupon.validity = `领取后${res.data.addDays}天有效`;
            this.coupon.validityType = res.data.validityType;
            this.coupon.couponDetail = res.data.couponDetail;
            this.coupon.couponName = res.data.couponName;
            this.coupon.couponId = res.data.couponId;
            this.coupon.couponList = res.data.couponList
              ? res.data.couponList
              : null;
            this.coupon.shopTitle =
              this.venderId == row.belongVenderId
                ? res.data.belongShopTitle + "（当前店铺）"
                : res.data.belongShopTitle;
            if (res.data.selectCrowdType == 3) {
              this.couponFrom.fileName = res.data.fileName;
              this.couponFrom.fileUrl = res.data.fileUrl;
            }
            if (res.data.selectCrowdType == 2) {
              this.couponFrom.pinList = res.data.pinList.join("\n");
            }
          }
        })
        .catch(() => {
          this.lookLoading = false;
        });
    },
    checkGrant(row) {
      this.detailDialogShow = true;
      this.detailLoading = true;
      this.grant.couponDetail = row.couponDetail;
      this.grant.name = row.couponName;
      this.grant.successNum = row.successNum || 0;
      let getid = "";
      if (row.putkey) {
        getid = row.putkey;
      } else {
        getid = row.couponId;
      }
      if (row.putkey) {
        byPutKey(getid).then((res) => {
          this.detailLoading = false;
          this.grant.endTime = res.data.endTime;
          this.grant.beginTime = res.data.beginTime;
          this.grant.shopTitle = row.belongShopTitle;
          this.grant.num = res.data.num || 0;
          this.grant.sendNum = res.data.sendNum;
          this.grant.takeBeginTime = res.data.takeBeginTime;
          this.grant.takeEndTime = res.data.takeEndTime;
          this.grant.addDays = res.data.addDays;
          this.detailFrom.id = row.rowId || row.id;
          if (row.rowId) {
            this.detailFrom.couponId = row.putkey;
            this.grant.successNum = res.data.sendNum;
          } else {
            this.detailFrom.couponId = "";
          }
          this.getRecordList();
          if (res.data.code == 0) {
            this.$message.error(res.data.message);
          }
        }).catch(() => {
          this.detailLoading = false;
        });
      } else {
        getCouponDetail(getid).then((res) => {
          this.detailLoading = false;
          this.grant.endTime = res.data.endTime;
          this.grant.beginTime = res.data.beginTime;
          this.grant.num = res.data.num;
          this.grant.sendNum = res.data.sendNum;
          this.grant.takeBeginTime = res.data.takeBeginTime;
          this.grant.takeEndTime = res.data.takeEndTime;
          this.grant.addDays = res.data.addDays;
          this.grant.shopTitle = res.data.shopTitle;
          this.detailFrom.id = row.rowId || row.id;
          if (row.rowId) {
            this.detailFrom.couponId = row.couponId;
            this.grant.successNum = res.data.sendNum;
          } else {
            this.detailFrom.couponId = "";
          }
          this.getRecordList();
        }).catch(() => {
          this.detailLoading = false;
        });
      }
    },
    getRecordList() {
      this.detailtalbeLoading = true;
      let data = { ...this.detailFrom };
      if (!this.detailFrom.couponId) {
        delete data.couponId;
      }
      queryRecordPage(data).then((res) => {
        this.detailtalbeLoading = false;
        let detailtableData = res.data.records;
        detailtableData.forEach((item) => {
          item.isShow = false;
        });
        this.detailtableData = detailtableData;
        this.detailTotal = +res.data.total;
      });
    },
    distributionBeansSure(data) {
      this.detailFrom = {
        ...this.detailFrom,
        customerPin: data.customerPin || "",
        sendStatus: data.sendStatus,
        sendType: 1,
        size: 10,
        current: 1,
      };
      this.getRecordList();
    },
  },
};
</script>

<style lang="scss" scoped>
.fz14 {
  font-size: 14px;
}
.coupon-tip-wrap {
  margin-top: 10px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}

.goodsselect_button {
  width: 145px;
  height: 32px;
  background: #f5f5f7;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  display: block;
  cursor: pointer;
  padding: 0 10px;
  border-radius: 2px;
  color: #333333;
  margin-left: 8px;
}

::v-deep .formitem_flex .el-form-item__content {
  display: flex;
  align-items: center;
}

.form_tip {
  width: 300px;
  background-color: #f4f4f5;
  padding: 8px 12px;
  font-size: 14px;
}

::v-deep .upload_item .el-form-item__content {
  position: relative;
  display: flex;
}

.detail_tip {
  padding: 12px;
  margin-bottom: 18px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.select_goods {
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
    display: flex;
    align-items: center;
  }
}

.imgs {
  width: 14px;
  vertical-align: middle;
  margin-right: 6px;
  margin-top: -2px;
}

.coupon-time {
  display: flex;
  margin-top: 16px;
  margin-left: 5px;

  .time-label {
    width: 80px;
    text-align: right;
  }
}
.pinBody {
  .pintitle {
    display: block;
  }
  .pinBu {
    display: none;
  }
  &:hover {
    .pintitle {
      display: none;
    }
    .pinBu {
      display: block;
    }
  }
}
.word-lineh {
  line-height: 18px;
}
.mt16 {
  margin-top: 16px;
}
.btn-style {
  padding: 0 !important;
  width: auto;
}
.btn-auto {
  width: auto;
}
.flex-spc-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.white-spacr-no {
  white-space: nowrap;
}
.flexc-cen-x {
  display: flex;
  align-items: center;
}
</style>
